import { createReducer, on, createFeature } from '@ngrx/store'
import { LeavePolicyState } from './leave-policy.state'
import {
  deleteAssignedTo,
  deleteAssignedToSuccess,
  loadAssignedTo,
  loadAssignedToFailure,
  loadAssignedToSuccess,
  loadLeavePolicyByIdFailure,
  loadLeavePolicyByIdSuccess,
  loadUnAssignedTo,
  loadUnAssignedToFailure,
  loadUnAssignedToSuccess,
  resetAssignedToState
} from './leave-policy.actions'

export const initialState: LeavePolicyState = {
  totalCount: 0,
  leavepolicies: [],
  assignedTo: null,
  loading: false,
  error: null,
  leavepolicy: null,
  unassignedTo: [],
  totalUserCount: 0
}

// Create the Role reducer
export const leavePolicyReducer = createReducer(
  initialState,

  on(loadLeavePolicyByIdSuccess, (state, { leavepolicy }) => {
    // console.log('leavepolicy', leavepolicy)
    return {
      ...state,
      leavepolicy: leavepolicy,
      error: null
    }
  }),
  on(loadLeavePolicyByIdFailure, (state, { error }) => ({
    ...state,
    leavepolicy: null,
    error
  })),
  on(loadAssignedTo, loadUnAssignedTo, deleteAssignedTo, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(
    loadAssignedToSuccess,

    (state, { assignedTo, totalCount }) => ({
      ...state,
      loading: false,
      error: null,
      assignedTo,
      totalCount
    })
  ),
  on(
    loadAssignedToFailure,
    loadUnAssignedToFailure,

    (state, { error }) => ({
      ...state,
      loading: false,
      error
    })
  ),
  on(
    loadUnAssignedToSuccess,

    (state, { unassignedTo, totalUserCount }) => ({
      ...state,
      loading: false,
      error: null,
      unassignedTo,
      totalUserCount: totalUserCount
    })
  ),
  on(resetAssignedToState, () => initialState)
)

// Create the feature for the Role state
export const leavePolicyFeature = createFeature({
  name: 'Leave Policy', // Feature name
  reducer: leavePolicyReducer
})
export type { LeavePolicyState }
// Export the feature's selectors
export const {
  name,
  reducer,
  selectAssignedTo,
  selectLoading,
  selectError,
  selectLeavepolicy,
  selectTotalCount,
  selectUnassignedTo,
  selectTotalUserCount
} = leavePolicyFeature
